import { BaseApiClient } from '../base-api-client';
export class TokenMetadataClient extends BaseApiClient {
    constructor(config) {
        const fullConfig = {
            ...config,
            baseURL: `${config.baseURL}/token-metadata`,
        };
        super(fullConfig, 'TokenMetadataClient');
    }
    async getTokenMetadata(symbol) {
        try {
            const response = await this.get(`/${encodeURIComponent(symbol)}`);
            return response ?? null;
        }
        catch (error) {
            console.error('[TokenMetadataClient] Error getting token metadata:', this.truncateError(error));
            return null;
        }
    }
}
//# sourceMappingURL=token-metadata-client.js.map